module.exports = __webpack_public_path__ + "img/deep_sleep-icon-2.1e5a2909.svg";